import React from 'react';
import PropTypes from 'prop-types';

export default function Title({ children }) {
  React.useEffect(() => {
    document.title = 'Help - Login with athenahealth';
  }, []);
  return children;
}

Title.propTypes = {
  children: PropTypes.node.isRequired,
};
